import {
  Component,
  EventEmitter,
  Input,
  NgModule,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActionPopupModule } from "../../../../action-popup/action-popup.component";
import {
  ColumnFormComponent,
  ColumnFormModule,
} from "../../option-data-grid-cartons/column-form/column-form.component";
import {
  ColumnFormData,
  MatrixColumnFormData,
} from "../../../../../model/calculation/optionPriceInformation";
import { ScreenService } from "../../../../../services";
import {
  MatrixColumnFormComponent,
  MatrixColumnFormModule,
} from "../matrix-column-form/matrix-column-form.component";
import { formatMessage } from "devextreme/localization";
import { OptionFormData } from "../../../../../model/calculation/optionFormData";

@Component({
  selector: "app-matrix-column-form-popup",
  templateUrl: "./matrix-column-form-popup.component.html",
  styleUrls: ["./matrix-column-form-popup.component.scss"],
})
export class MatrixColumnFormPopupComponent implements OnInit {
  @ViewChild(MatrixColumnFormComponent)
  form: MatrixColumnFormComponent;

  formatMessage = formatMessage;

  @Input() visible: boolean;
  @Input() columnForm: MatrixColumnFormData;
  @Input() formCaption: string = formatMessage("option.column.create");
  @Input() optionData: OptionFormData;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onSave = new EventEmitter<MatrixColumnFormData>();

  constructor(private screen: ScreenService) {}

  ngOnInit(): void {}

  resetColumnForm(): void {
    this.form.resetValues();
  }

  save(): void {
    if (!this.form.isValid()) {
      return;
    }

    this.onSave.emit(this.columnForm);

    this.visible = false;
  }
}
@NgModule({
  imports: [ActionPopupModule, ColumnFormModule, MatrixColumnFormModule],
  exports: [MatrixColumnFormPopupComponent],
  declarations: [MatrixColumnFormPopupComponent],
})
export class MatrixColumnFormPopupModule {}
